import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router';

import Typography from '@/components/Typography';

const OnboardingFooter = () => {
  return (
    <Typography
      sx={{
        fontWeight: 500
      }}
    >
      Already have an account?{' '}
      <Link
        color='primary.main'
        component={RouterLink}
        rel='noopener noreferrer'
        sx={{
          fontWeight: 500,
          fontSize: 16,
          pl: 0.5,
          textDecoration: 'none'
        }}
        to='../login'
      >
        Login
      </Link>
    </Typography>
  );
};

export default OnboardingFooter;
